import * as React from 'react';
import {useEffect, useState} from 'react';
import {withNavigation} from '../navigation/navigation';
import {
  Paper,
  Button,
  Stack,
  Typography,
  Breadcrumbs,
  Skeleton,
  Box,
} from '@mui/material';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import ItemDetailDescription from './ItemDetailDescription';
import ItemDetailInformation from './ItemDetailInformation';
import {withItemDetailContext} from './state/itemDetailContext';
import {useItemDetail} from './hooks/useItemDetail';
import {useParams} from 'react-router-dom';
import Slider from 'react-slick';
import ServiceItem from '../service/ServiceItem';
import {useNavigate} from 'react-router-dom';
import {withServiceListContext} from '../service/state/serviceContext';

const ItemDetail = ({setShowNav}) => {
  const {id} = useParams();
  const {mode} = useDarkMode();
  const {item, loading, fetchItemDetail} = useItemDetail(id);
  const [finalList, setFinalList] = useState(<div></div>);
  const [finalNbr, setFinalNbr] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    fetchItemDetail(id);
  }, [id]);

  useEffect(() => {
    console.log('iiii', item);
    if (item.relatedProducts) {
      if (item.relatedProducts.length === 0) {
        return;
      }
      const res = renderResult(item.relatedProducts);
      setFinalList(res[0]);
      setFinalNbr(res[1]);
    }
  }, [item]);

  const renderResult = list => {
    const final = [];
    list.forEach(child => {
      switch (child.category) {
        case 'service':
          final.push(renderCardSlide(child));

          break;
        case 'conseil':
          final.push(renderCardSlide(child));

          break;
        case 'produit':
          final.push(renderCardSlide(child));

          break;
        default:
      }
    });
    return [final, final.length];
  };

  const renderCardSlide = product => {
    console.log('products', product);
    return (
      <ServiceItem
        id={product.id}
        title={product.name}
        description={product.description}
        variant={product.category}
        image={product.image}
        variantName={product.category}
        controls={['show-detail', 'marketplace']}
        treading={false}
        treadingBadge={false}
        isFavorite={false}
        addMargin={false}
      />
    );
  };

  const settingsServices = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: finalNbr <= 2 ? finalNbr : 2,
    arrows: true,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          variableWidth: false,
          arrows: true,
          centerPadding: '0px',
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 2,
          variableWidth: false,
          centerPadding: '0px',
          arrows: true,
        },
      },
    ],
    variableWidth: false,
    centerPadding: '120px',
    centerMode: true,
  };

  useEffect(() => {
    setShowNav(false);
  }, []);

  return (
    <Stack style={{marginTop: '15px'}}>
      <Breadcrumbs
        separator="›"
        aria-label="navigation"
        style={{color: mode.settings.textColor3}}>
        {[
          <Typography
            className={'breadcrumbs'}
            variant={'body2'}
            onClick={() => navigate('/')}
            style={{color: mode.settings.breadcrumbColor1}}>
            Accueil
          </Typography>,
          <Typography
            variant={'body2'}
            style={{color: mode.settings.textColor3}}
            onClick={() => navigate('/product-search')}
            className={'breadcrumbs'}>
            Produits et services
          </Typography>,
          <Typography
            variant={'body2'}
            style={{color: mode.settings.textColor7}}>
            {item.product ? item.product.name : ''}
          </Typography>,
        ]}
      </Breadcrumbs>
      <Typography
        variant="h5"
        sx={{
          mt: {xs: 2, md: 2, lg: 2},
          mb: {xs: 4, md: 4, lg: 2},
          textAlign: {xs: 'center', md: 'center', lg: 'left'},
        }}
        style={{color: mode.settings.textColor3}}
        id={'anchor0'}>
        Détail du service
      </Typography>
      {!loading && (
        <Stack direction={'column'}>
          <Paper
            style={{
              backgroundColor: mode.settings.cardBackgroundColor,
              width: 'inherit',
              maxWidth: '1000px',
              padding: '15px',
            }}>
            <Stack
              direction={'row'}
              gap={5}
              flexWrap={'wrap'}
              justifyContent={'center'}>
              <ItemDetailDescription item={item} loading={loading} />
              <ItemDetailInformation item={item} loading={loading} />
            </Stack>
          </Paper>
          {finalNbr > 0 && (
            <Typography
              variant="h5"
              sx={{
                mt: {xs: 2, md: 2, lg: 2},
                mb: {xs: 4, md: 4, lg: 2},
                textAlign: {xs: 'center', md: 'center', lg: 'left'},
              }}
              style={{color: mode.settings.textColor3}}
              id={'anchor0'}>
              {' '}
              Vous aimerez aussi{' '}
            </Typography>
          )}
          {finalNbr > 0 && <Slider {...settingsServices}>{finalList}</Slider>}
        </Stack>
      )}
      {loading && (
        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}>
          <Skeleton width={300} height={400} />
          <Box sx={{paddingTop: '81px'}}>
            <Stack sx={{marginBottom: 2}} direction="row" spacing={2}>
              <Skeleton width={70} height={40} />
              <Skeleton width={70} height={40} />
              <Skeleton width={70} height={40} />
            </Stack>
            <Skeleton width={207} height={28} />
            <Skeleton width={700} height={28} />
            <Skeleton width={700} height={28} />
            <Skeleton width={407} height={48} sx={{marginTop: '67px'}} />
          </Box>
        </Stack>
      )}
    </Stack>
  );
};

export default withServiceListContext(
  withNavigation(withItemDetailContext(ItemDetail)),
);
